export enum DataConnectorsMenuPages {
  Configured,
  AddNew,
}
